var map = {
	"./pr-1.png": "a788",
	"./pr-10.png": "ff2f",
	"./pr-11.png": "a338",
	"./pr-2.png": "8899",
	"./pr-3.png": "1a70",
	"./pr-4.png": "de54",
	"./pr-5.png": "0f07",
	"./pr-6.png": "e2ce",
	"./pr-7.png": "0df9",
	"./pr-8.png": "fe2c",
	"./pr-9.png": "5f5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85f2";